import { useParams } from "react-router-dom"
import { useManageHoopsGetDef } from "../../hooks/hoops/useManageHoopsGetDef";
import { ContentHeader, MainContentArea } from "melco-ui";
import { UpdateHoopForm } from "../../components/hoops/UpdateHoopForm";
import { ALL_PUBLISHED_STATES } from "../../helper/publishedState";
import { HeaderButtonArea } from "melco-shared-logic";
import { HoopMoreActionButton } from "../../components/hoops/HoopMoreActionsButton";
import { useRolesContext } from "../../hooks/roles/useRolesContext";

export const UpdateHoop: React.FC = () => {

    const { hoopId } = useParams();
    const { query: { data: hoop, refetch }, queryKey } = useManageHoopsGetDef(hoopId ?? "", ALL_PUBLISHED_STATES)
    //const hoop = undefined
    const { roles } = useRolesContext();


    return <> <MainContentArea
        header=
        {
            hoop && hoop && <ContentHeader
                title={hoop.cloud_id}
                extra={
                    <>

                        {
                            roles.SYSTEM_HOOPS_DELETE && hoop?.version === 2 &&
                            <>
                                <HeaderButtonArea />

                                <HoopMoreActionButton
                                    hoop={hoop}

                                />

                            </>}

                    </>

                } />

        }
        contentPadding
    >
        {hoop && <UpdateHoopForm queryKey={queryKey} refetch={refetch} hoop={hoop} />}

    </MainContentArea >
    </>





}